import type { PropType } from 'vue'
import type { UnionFromTuple } from '@oen.web.vue/utils'
import { analyticsNameProp } from '../common/props'
import { themes } from './variants'

type Themes = UnionFromTuple<typeof themes>

export const sharedButtonProps = {
  theme: {
    type: String as PropType<Themes>,
    default: 'primary',
    validator(value: Themes) {
      return themes.includes(value)
    },
  },
  loading: {
    type: Boolean,
    default: false,
  },
  ...analyticsNameProp,
}
